import React, { useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import vaccineFormStyle from "components/AddVaccineForm/AddVaccineForm.module.css";
import { SelectField, TextField } from "components/AddVaccineForm/components";
import { Checkbox } from "components/ui/Checkbox";
import { HealthMailContactOrEmailField } from "features/results/components/HealthMailContactOrEmailField/HealthMailContactOrEmailField";
import { PRIMARY_GP_CONTACT_TITLES } from "features/results/constants/healthMailContactTitles";
import { selectableFinancialClasses } from "utils/patientFormOptions";

import s from "../PatientProfileForm.module.css";

export function PatientProfileClassificationGpSection({
  isCreate,
  doctors,
  primaryGpContact,
}) {
  const { setValue, trigger } = useFormContext();
  const noPpsn = useWatch({ name: "noPpsn" });

  const onNoPpsnChange = (e) => {
    const checked = e.target.checked;
    setValue("noPpsn", checked);

    if (checked) {
      setValue("nationalNumber", "");
    }
  };

  const onFinancialClassChange = useCallback(
    (value) => {
      setValue("financialClass", value);
      setValue("gms", value === "02" || value === "04");
    },
    [setValue]
  );

  const sectionClass = isCreate ? s.sectionCreate : s.sectionEdit;
  const headerClass = isCreate ? s.sectionHeader : s.sectionHeaderEdit;

  return (
    <div className={sectionClass}>
      <h3 className={headerClass}>Social Welfare</h3>
      <div className={s.formGrid3Gp}>
        <div className={s.ppsnField}>
          <TextField
            name="nationalNumber"
            label="PPS Number"
            placeholder={noPpsn ? "No PPSN issued" : "Enter PPS number"}
            disabled={!!noPpsn}
            onBlur={() => !noPpsn && trigger("nationalNumber")}
          />
          {/* Sits in the label row, so the box lines up with its neighbours. */}
          <label className={s.ppsnNotIssued}>
            not issued
            <Checkbox checked={!!noPpsn} onChange={onNoPpsnChange} />
          </label>
        </div>
        <SelectField
          name="financialClass"
          label="Patient Classification"
          options={selectableFinancialClasses}
          placeholder="Select"
          onChange={onFinancialClassChange}
        />
        <TextField
          name="medicalCardNumber"
          label="Medical Card Number"
          placeholder="Enter medical card number"
        />
      </div>
      <div className={`${s.formGrid3Gp} ${s.formGridRow}`}>
        <SelectField
          name="doctorDetailsId"
          label="Main Doctor"
          options={doctors.map((doc) => ({
            label: doc.label,
            value: String(doc.value),
          }))}
          placeholder="Select"
          onChange={(value) => {
            setValue("doctorDetailsId", value);
          }}
        />
        <HealthMailContactOrEmailField
          contactName="primaryGpContactId"
          emailName="primaryGpEmail"
          label="Primary GP"
          titles={PRIMARY_GP_CONTACT_TITLES}
          initialContact={primaryGpContact}
          labelClassName={vaccineFormStyle.pregnancyFormLabel}
        />
      </div>
    </div>
  );
}
